import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useBreakpointValue,
  useToast,
  VStack,
} from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DashboardHeader from "../../../components/common/DashboardHeader";
import Loading from "../../../components/common/Loading";
import TraineeSidenav from "../../../components/trainee/courses/Sidenav";
import emptyAnnouncement from "../../../img/emptyAnnouncement.svg";
import rarrow from "../../../img/rarrow.svg";
import speaker from "../../../img/speaker.svg";
import { IAnnouncement } from "../../../models/trainee-course.model";
import trainercoursesService from "../../../services/trainer/trainercourses.service";
import courseRoutes from "../../courses/courseRoutes";
import TraineeMobileNav from "../../../components/common/TraineeMobileNav";

const Announcement = () => {
  const [courseAnnouncements, setCourseAnnouncements] = useState<
    IAnnouncement | any
  >([]);
  const navigate = useNavigate();
  const toast = useToast();
  const params = useParams();
  const course_id: any = params.course_id;
  const [loading, setLoading] = useState(true);

  const courseName: null | string = localStorage.getItem("courseName");
  const showSideNav = useBreakpointValue({ base: false, md: true, lg: true });

  // const announcement_id:any = params.announcement_id;

  // for get course announcements
  useEffect(() => {
    if (course_id)
      trainercoursesService.getCourseAnnouncement(course_id).then((res) => {
        setCourseAnnouncements(res.data);
        setLoading(false);
      });
  }, [course_id]);

  const sortRecentFirst = () => {
    setCourseAnnouncements(
      [...courseAnnouncements].sort((a: any, b: any) => {
        return b.created_at > a.created_at
          ? 1
          : b.created_at === a.created_at
          ? 0
          : -1;
      })
    );
    return courseAnnouncements;
  };

  const sortOldestFirst = () => {
    setCourseAnnouncements(
      [...courseAnnouncements].sort((a: any, b: any) => {
        return a.created_at > b.created_at
          ? 1
          : a.created_at === b.created_at
          ? 0
          : -1;
      })
    );
    return courseAnnouncements;
  };

  return (
    <>
      <DashboardHeader />
      {loading ? (
        <Loading />
      ) : (
        <Box
          bg="#F9F8F8"
          minHeight="100vh"
          width="auto"
          pt={"0.1rem"}
          pb={"2rem"}
          height={"auto"}
          mx="auto"
        >
          {!showSideNav && <TraineeMobileNav courseId={course_id || ""} />}
          <Flex
            p="1rem"
            mx="auto"
            pt={["50px", "60px", "60px", "80px"]}
            width={{ lg: "90%", md: "90%", sm: "100%", base: "100%" }}
            minHeight="100vh"
            height="max-content"
            pb={"30px"}
          >
            {showSideNav && <TraineeSidenav />}
            <VStack width="100%">
              <HStack width={"100%"} height={"2rem"}>
                <Text
                  as="span"
                  fontSize={["16px", "20px"]}
                  isTruncated
                  maxWidth={["180px", "200px", "350px", "500px"]}
                >
                  {courseName?.replaceAll(/"/g, "")}
                </Text>
                <Image src={rarrow} />
                <Text as="span" fontSize={["16px", "20px"]} color={"#616161"}>
                  Announcements
                </Text>
              </HStack>

              <Box
                width="100%"
                minHeight="90vh"
                height="auto"
                mb="2rem"
                mx="auto"
                padding={{
                  lg: "2.5rem",
                  md: "2rem",
                  sm: "1.4rem",
                  base: "1.4rem",
                }}
                bg="white"
              >
                <Text
                  color="#1E1E1E"
                  fontSize={{
                    lg: "28px",
                    md: "20px",
                    sm: "18px",
                    base: "18px",
                  }}
                  pb="30px"
                  fontWeight="600"
                >
                  Announcements{" "}
                </Text>
                <Flex justifyContent="space-between" alignItems="center">
                  <Text fontSize="16px" color="#E53E3E">
                    All ({courseAnnouncements.length})
                  </Text>
                  <Menu>
                    <MenuButton
                      fontSize={{
                        lg: "14px",
                        md: "13px",
                        sm: "13px",
                        base: "12px",
                      }}
                      color={"#EC3337"}
                      as={Button}
                      rightIcon={<ChevronDownIcon />}
                      sx={{
                        border: "1px solid #EC3337",
                        padding: "7px",
                        borderRadius: "2px",
                        backgroundColor: "white",
                        _hover: {
                          backgroundColor: "transparent",
                        },
                        _active: {
                          backgroundColor: "transparent",
                        },
                      }}
                    >
                      Sort By
                    </MenuButton>
                    <MenuList width="5rem">
                      <MenuItem
                        fontSize={{
                          lg: "14px",
                          md: "13px",
                          sm: "13px",
                          base: "12px",
                        }}
                        as={Button}
                        onClick={sortRecentFirst}
                      >
                        Recent First
                      </MenuItem>
                      <MenuItem
                        fontSize={{
                          lg: "14px",
                          md: "13px",
                          sm: "13px",
                          base: "12px",
                        }}
                        as={Button}
                        onClick={sortOldestFirst}
                      >
                        Oldest First
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Flex>
                <Box>
                  {loading ? (
                    <Loading />
                  ) : courseAnnouncements.length > 0 ? (
                    <Box mt="1.4rem" minHeight={"50vh"}>
                      {courseAnnouncements?.map((each: any, index: any) => (
                        <Flex
                          key={index}
                          cursor="pointer"
                          justifyContent="space-between"
                          flexDirection={{
                            lg: "row",
                            md: "row",
                            sm: "column",
                            base: "column",
                          }}
                          borderLeft="1px solid"
                          borderColor="#EC3337"
                          alignItems="center"
                          mb="30px"
                          padding={{
                            lg: "1rem",
                            md: "0.8rem",
                            sm: "0.6rem",
                            base: "0.5rem",
                          }}
                          boxShadow="base"
                          height="auto"
                          onClick={() =>
                            navigate(
                              courseRoutes.EachAnnouncementLink(
                                course_id,
                                each.id
                              )
                            )
                          }
                        >
                          <Flex
                            width={{
                              lg: "63%",
                              md: "70%",
                              sm: "90%",
                              base: "90%",
                            }}
                            alignItems="center"
                            mr="10px"
                            ml="25px"
                          >
                            <Image
                              src={speaker}
                              height="10%"
                              width="10%"
                              display={{
                                lg: "block",
                                md: "block",
                                sm: "none",
                                base: "none",
                              }}
                            />
                            <Box>
                              <Text
                                fontWeight="600"
                                color="#616161"
                                fontSize={{
                                  lg: "20px",
                                  md: "18px",
                                  sm: "14px",
                                  base: "14px",
                                }}
                              >
                                {each.title}
                              </Text>
                              <Text
                                fontWeight="400"
                                color=" #B9B9B9"
                                mt="5px"
                                mb="5px"
                                fontSize={{
                                  lg: "12px",
                                  md: "11px",
                                  sm: "10px",
                                  base: "10px",
                                }}
                              >
                                Posted by {each.user.name}
                              </Text>
                              <Text
                                fontSize={{
                                  lg: "14px",
                                  md: "13px",
                                  sm: "12px",
                                  base: "12px",
                                }}
                                fontWeight="400"
                                color=" #B9B9B9"
                              >
                                {each.description.slice(0, 150)}...
                              </Text>
                            </Box>
                          </Flex>
                          <Box
                            width={{
                              lg: "auto",
                              md: "auto",
                              sm: "90%",
                              base: "90%",
                            }}
                            padding={{
                              lg: "1rem",
                              md: "0.8rem",
                              sm: "0.6rem",
                              base: "0.5rem",
                            }}
                          >
                            <Text fontSize="12px" color="#616161">
                              Posted
                            </Text>
                            <Text color="#B9B9B9" fontSize="11px">
                              {moment(each.created_at).fromNow()}
                            </Text>
                          </Box>
                        </Flex>
                      ))}
                    </Box>
                  ) : (
                    <Center width={"100%"} height={"100%"}>
                      <Flex
                        // mt="1.6rem"
                        height="60vh"
                        flexDirection="column"
                        justifyContent="center"
                        marginTop="1rem"
                        alignContent="center"
                        gap="0.5rem"
                        width={"100%"}
                      >
                        <Image
                          src={emptyAnnouncement}
                          alt="Empty announcement"
                          height={{
                            lg: "16rem",
                            md: "14rem",
                            sm: "13rem",
                            base: "12rem",
                          }}
                          width={{
                            lg: "16rem",
                            md: "14rem",
                            sm: "13rem",
                            base: "12rem",
                          }}
                          m="0 auto"
                        />
                        <Text
                          fontSize={{
                            lg: "36px",
                            md: "28px",
                            sm: "22px",
                            base: "18px",
                          }}
                          fontWeight="600"
                          textAlign="center"
                        >
                          No Announcements
                        </Text>
                        <Text
                          fontSize={{ lg: "16px", md: "12px", sm: "11px" }}
                          textAlign="center"
                        >
                          There are no announcements yet.
                        </Text>
                      </Flex>
                    </Center>
                  )}
                </Box>
                {/* <Tabs colorScheme="red">
                              <TabList>
                                  <Tab>All ({courseAnnouncements.length})</Tab>
                                  <Tab>Read</Tab>
                              </TabList>
                              <TabPanels>
                                  <TabPanel>
                                      {
                                          loading ? <Loading/> :
                                          courseAnnouncements.length > 0 ? 
                                              <Box mt="1.4rem">
                                                  {courseAnnouncements?.map((each: any, index: any) => (
                                                  <Flex key={index} cursor='pointer' justifyContent='space-between' borderLeft='1px solid' borderColor='#EC3337' alignItems='center' mb='30px' pr='30px' py='8px' boxShadow='base' height="auto" onClick={() => navigate(courseRoutes.EachAnnouncementLink(course_id, each.id))}>
                                                      <Flex width='63%' alignItems='center' mr='10px' ml='25px'>
                                                          <Image src={speaker} height="10%" width="10%" />
                                                          <Box >
                                                              <Text fontWeight='600' color='#616161' fontSize='20px'>{each.title}</Text>
                                                              <Text fontWeight='400' color=' #B9B9B9' mt='5px' mb='5px' fontSize='12px'>Posted by {each.user.name}</Text>
                                                              <Text fontSize='14px' fontWeight='400' color=' #B9B9B9' >
                                                                  {each.description.slice(0, 150)}...
                                                              </Text>
                                                          </Box>
                                                      </Flex>
                                                      <Box>
                                                          <Text fontSize='12px' color='#616161'>Posted</Text>
                                                          <Text color='#B9B9B9' fontSize='11px'>{moment(each.created_at).fromNow()}</Text>
                                                      </Box>
  
                                                  </Flex>
                                                  ))
                                                  }
  
                                              </Box> 
                                              :
                                              <Center>
                                                  <Flex mt="1.6rem" height="70vh" flexDirection="column" justifyContent="center" marginTop="1rem" alignContent="center" gap="0.5rem">
                                                      <Image src={emptyAnnouncement} alt="Empty announcement" height="18rem" width="18rem" />
                                                      <Text fontSize="40px" fontWeight="600">No Announcements</Text>
                                                      <Text fontSize="16px">There are no announcements yet.</Text>
                                                  </Flex>
                                              </Center>
                                      }
                                  </TabPanel>
                                  <TabPanel> 
                                  </TabPanel>
                                  <TabPanel>
                                      <p>three!</p>
                                  </TabPanel>
                              </TabPanels>
                          </Tabs> */}
              </Box>
            </VStack>
          </Flex>
        </Box>
      )}
    </>
  );
};

export default Announcement;
